import { useRealtimeStore } from '../../stores/realtimeStore'
import { useBuildingStore } from '../../stores/buildingStore'
import '../../styles/panels.css'

const BATTERY_LEVELS = [
  { min: 80, color: '#4ade80', label: '> 80%' },
  { min: 50, color: '#facc15', label: '50-80%' },
  { min: 20, color: '#f97316', label: '20-50%' },
  { min: 0, color: '#ef4444', label: '< 20%' },
]

function getBatteryColor(level: number): string {
  for (const b of BATTERY_LEVELS) {
    if (level >= b.min) return b.color
  }
  return '#ef4444'
}

export default function LuxNavixFilters() {
  const showBatteries = useRealtimeStore((s) => s.showBatteries)
  const showTopology = useRealtimeStore((s) => s.showTopology)
  const showOptimalOnly = useRealtimeStore((s) => s.showOptimalOnly)
  const filterOffline = useRealtimeStore((s) => s.filterOffline)
  const rssiThreshold = useRealtimeStore((s) => s.rssiThreshold)
  const setShowBatteries = useRealtimeStore((s) => s.setShowBatteries)
  const setShowTopology = useRealtimeStore((s) => s.setShowTopology)
  const setShowOptimalOnly = useRealtimeStore((s) => s.setShowOptimalOnly)
  const setFilterOffline = useRealtimeStore((s) => s.setFilterOffline)
  const setRssiThreshold = useRealtimeStore((s) => s.setRssiThreshold)
  const batteries = useRealtimeStore((s) => s.batteries)
  const badges = useBuildingStore((s) => s.badges)

  return (
    <div className="luxnavix-filters">
      <div className="panel-section__title">Filtres LuxNavix</div>

      <label className="luxnavix-filters__toggle">
        <input
          type="checkbox"
          checked={showBatteries}
          onChange={(e) => setShowBatteries(e.target.checked)}
        />
        Afficher batteries
      </label>

      {showBatteries && (
        <div className="luxnavix-filters__battery-list">
          {badges.map((badge) => {
            const level = batteries.get(badge.badge_code) ?? 100
            return (
              <div key={badge.id} className="luxnavix-filters__battery-item">
                <span className="luxnavix-filters__battery-name">{badge.name}</span>
                <span
                  className="luxnavix-filters__battery-chip"
                  style={{ background: getBatteryColor(level) }}
                >
                  {level}%
                </span>
              </div>
            )
          })}
          <div className="luxnavix-filters__legend">
            {BATTERY_LEVELS.map((b) => (
              <span key={b.label} className="luxnavix-filters__legend-item">
                <span className="luxnavix-filters__legend-dot" style={{ background: b.color }} />
                {b.label}
              </span>
            ))}
          </div>
        </div>
      )}

      <label className="luxnavix-filters__toggle">
        <input
          type="checkbox"
          checked={showTopology}
          onChange={(e) => setShowTopology(e.target.checked)}
        />
        Afficher topologie
      </label>

      {showTopology && (
        <label className="luxnavix-filters__toggle luxnavix-filters__toggle--sub">
          <input
            type="checkbox"
            checked={showOptimalOnly}
            onChange={(e) => setShowOptimalOnly(e.target.checked)}
          />
          Routes optimales uniquement
        </label>
      )}

      <label className="luxnavix-filters__toggle">
        <input
          type="checkbox"
          checked={filterOffline}
          onChange={(e) => setFilterOffline(e.target.checked)}
        />
        Filtrer offline
      </label>

      <div className="luxnavix-filters__slider">
        <label className="luxnavix-filters__slider-label">
          Seuil RSSI: {rssiThreshold} dBm
        </label>
        <input
          type="range"
          min="-100"
          max="-30"
          step="1"
          value={rssiThreshold}
          onChange={(e) => setRssiThreshold(parseInt(e.target.value))}
        />
      </div>
    </div>
  )
}
